document.addEventListener('DOMContentLoaded', function() {
    var valid_doctor_list = [];
    var doctor_list = document.getElementsByClassName('doctor-list');
    var step2 = document.getElementsByClassName('step2');
    var find_widget_results_class= document.getElementsByClassName('c-find-widget__results');
    var findWidget = document.getElementById('findWidget');


    if(findWidget == null) {
        return false;
    }

    findWidget.addEventListener( "submit", function (e) {
        e.preventDefault();
        onClick();
    } );

    function onClick() {
        //Get lat, lng and radius once submit button is clicked
        var curent_lat = document.getElementById('js-current_lat').value;
        var current_lng = document.getElementById('js-current_lng').value;
        var current_radius = parseInt(document.getElementById('find-near_choose-radius').value);
        var data_type = document.getElementsByClassName('inline-access-search')[0].dataset.type;

        //Validate that an address found
        if(curent_lat && curent_lat) {
            //Get lat and lng to user input location
            var user_input_location = new google.maps.LatLng(curent_lat, current_lng);
            
            // Clear content before sending data to JSONdata function
            clearContent();
            getJSONdata(user_input_location, current_radius, data_type);
        }
    }
    
    //Converts meters to miles
    function getMiles(meters) {
        return meters * 0.000621371192;
    }

    function getJSONdata(user_input_location, radius, data_type) {

        var request = new XMLHttpRequest();
        request.open('GET', '/wp-content/uploads/locations-1.json', true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var data = JSON.parse(request.response);
                data.forEach(function(data, index) {
                    var post_address = new google.maps.LatLng(data.lat, data.lng);
                    var distance_between_points = getMiles(google.maps.geometry.spherical.computeDistanceBetween(user_input_location, post_address));

                    //If object is within the given radius, create new object and push to array
                    if(distance_between_points < radius) {
                        var current_post = {
                            post_info : data,
                            distance : distance_between_points
                        }
                        
                        //Check to see if the data type is center then remove post if it is external
                        if(data_type == 'center'){
                            if(data.treatment_center_external == true) {
                                return;
                            }
                        }
                        //Push object into array and sort by distance closests
                        valid_doctor_list.push(current_post);

                        valid_doctor_list.sort(function(a, b){
                            return a.distance - b.distance;
                        });
                    }
                });

                //Filter out duplicates cancer centers
                if(data_type == 'center') {
                    valid_doctor_list = valid_doctor_list.filter(function(value, index, self) {
                        return index === self.findIndex(function(i) {
                            return i.post_info.treatment_center_id === value.post_info.treatment_center_id;
                        });
                    });
                }
                
                //Create doctor/treatment cards and reinit lighbox
                buildCards(data_type);
                findWidget.classList.remove('c-form--submitting')
                initAddedDomPopup();
            }
        };
        request.send();
    }

    function clearContent() {
        valid_doctor_list = [];
        doctor_list[0].innerHTML = '';
        find_widget_results_class[0].innerHTML = '';
    }

    function initAddedDomPopup() {
        const modalElements = document.querySelectorAll('[data-modal-src]');
        
        modalElements.forEach((modal) =>{
            if(modal.getAttribute('data-modal-src')==='#contact__modal'){
                const modalID =  modal.getAttribute('data-modal-src').replace('#', '');
            
                modal.addEventListener('click', (e) => {
                    MicroModal.show(modalID,{
                        disableScroll: true,
                        })
                });
            }
        })
    }


    //Building out cards via dom, but changing to Ajax call
    function buildCards(data_type) {

        var find_widget_results = '<h5 style="margin-top: 0;">' + valid_doctor_list.length + ' Results Found Near <span style="color: #127ea5;">' + document.getElementById('js-current_address_name').value +'</span> </h5>'

        //Loop through each doctor/treatment center
        valid_doctor_list.forEach(function(post) {

            var distance_between, treatment_center, profile_image_info, profile_block_title_info, profile_button_info;
            
            //Truncate decimals based on the distance from doctor/treatment to user
            //Check to see if treatment center is external
            post.distance > 10 ? distance_between = Math.trunc(post.distance) :  distance_between = post.distance.toFixed(1);
            post.post_info.treatment_center_external != true ? treatment_center = post.post_info.treatment_center_link : treatment_center = post.post_info.treatment_center_external_url;

            //Build cards based on if the data type is center or doctor
            if(data_type == 'center') {
                profile_image_info = '<img class="o-image o-image--avatar c-profile-block__image" src="' + post.post_info.treatment_center_thumbnail + '" alt="' + post.post_info.treatment_center_name + '">';
                profile_block_title_info = '<div class="c-profile-block__name-container"><a class="c-profile-block__name" data-ctaid="Green Button:Contact ' + post.post_info.treatment_center_name + '" onclick="ga(\'send\', \'event\', \'Green Button\', \'Click\', \''+ post.post_info.treatment_center_name + '\');" href="' + post.post_info.treatment_center_link + '">'+ post.post_info.treatment_center_name + '</a><a class="c-button c-button--outline c-button--s" rel="noopener noreferrer" target="_blank" href="https://maps.google.com/?q='+ post.post_info.lat + ',' + post.post_info.lng + '"><i class="o-icon o-icon--location"></i></a></div>'+ post.post_info.address;
                profile_button_info = '<button class="c-button c-button--secondary js-modalLightbox js-trackClicks" data-modal-src="#contact__modal" data-requestedservice="Doctor Match" data-formname="Doctor Match" data-formcategory="Doctor" data-imgsrc="'+ post.post_info.treatment_center_thumbnail+ '" data-posttitle="' + post.post_info.treatment_center_name + '">Get in Touch</button>';
            } else {
                profile_image_info = '<img class="o-image o-image--avatar c-profile-block__image" src="'+ post.post_info.thumbnail + '" alt="' + post.post_info.post_title + ' headshot">';
                profile_block_title_info = '<div class="c-profile-block__name-container"><a class="c-profile-block__name" data-ctaid="Green Button:Contact ' + post.post_info.post_title + '" onclick="ga(\'send\', \'event\', \'Green Button\', \'Click\', \'' + post.post_info.post_title + '\');" href="' + post.post_info.page_link + '">' + post.post_info.post_title + ', M.D.</a><a class="c-button c-button--outline c-button--s" rel="noopener noreferrer" target="_blank" href="https://maps.google.com/?q=' + post.post_info.lat + ',' + post.post_info.lng + '"><i class="o-icon o-icon--location"></i></a></div><span class="c-doctor-specialty">'+ post.post_info.specialty + '</span><a rel="nofollow" data-ctaid="Green Button:Content Associated Cancer Center '+ treatment_center + '" onclick="ga(\'send\', \'event\', \'Green Button\', \'Click\', \'Content Associated Cancer Center ' + post.post_info.treatment_center_name + '\');" href="' + treatment_center + '" class="c-doctor-location">'+ post.post_info.treatment_center_name + '</a> · <span class="c-doctor-distance">' + distance_between + ' mi</span>';
                profile_button_info = '<button class="c-button c-button--secondary js-modalLightbox js-trackClicks" data-modal-src="#contact__modal" data-requestedservice="Doctor Match" data-formname="Doctor Match" data-formcategory="Doctor" data-imgsrc="' + post.post_info.thumbnail + '" =""="" data-posttitle="' + post.post_info.post_title + '">Get in Touch</button>'
            }

            var profile_block = document.createElement("div");
            profile_block.className = "c-profile-block c-profile-block--detailed";
            var profile_image_wrapper = document.createElement("div");
            profile_image_wrapper.className = "c-profile-block__image-wrapper";
            var profile_heading = document.createElement("div");
            profile_heading.className = "c-profile-block__heading";
            var profile_block_title = document.createElement("div");
            profile_block_title.className = "c-profile-block__title";
            var profile_content = document.createElement("div");
            profile_content.className = "c-profile-block__content";
            var profile_buttons = document.createElement("div");
            profile_buttons.className = "c-profile-block__buttons";

            profile_image_wrapper.innerHTML += profile_image_info;
            profile_buttons.innerHTML += profile_button_info;
            profile_block_title.innerHTML += profile_block_title_info;

            profile_content.appendChild(profile_buttons);
            profile_heading.appendChild(profile_block_title);
            profile_heading.appendChild(profile_content);
            profile_block.appendChild(profile_image_wrapper);
            profile_block.appendChild(profile_heading);
            
            doctor_list[0].appendChild(profile_block);
        });

        find_widget_results_class[0].innerHTML = find_widget_results;
        step2[0].style.display = "block";
    }

});

